// Ledger Mutations

export const updateLedgerList = (state, payload) => {
  state.ledgerList = payload
}

export const updateLedgerDetailList = (state, payload) => {
  state.ledgerDetailList = payload
}
